import React, { Component } from 'react';
import { FaUser, FaPhone, FaBuilding, FaComment, FaArrowRight, FaArrowLeft, FaTrash } from 'react-icons/fa';


const iconComponents = {
	user: FaUser,
	phone: FaPhone,
	building: FaBuilding,
	sms: FaComment
};
class Domains extends Component {
	constructor(props) {
		super(props);
		this.state = {
			active: false,
			editingSetting: false,
			loading: false,
			domain: false,
			filterBy: {},
			sortBy: '',
			sortOrder: 1,
			availableLanguages: ['English', 'Spanish'],
			importSystemPrompts: false
		};
	}
	//Whole Page
	cancel = () => {
		this.setState({ addDomain: false, tempDomain: false, loading: false, error: false })
	}
	checkType = (e) => {
		console.log(e.target.value)
		this.setState({ type: e.target.value })
	}
	filter = (field) => (e) => {
		var filterBy = this.state.filterBy
		if (e.target.value.length > 0) {
			filterBy[field] = e.target.value
		} else {
			delete filterBy[field]
		}
		this.setState({ filterBy: filterBy })
	}
	sort = (sortBy) => (e) => {
		var sortOrder
		if (this.state.sortOrder === -1) {
			sortOrder = 1;
		} else {
			sortOrder = -1;
		}
		this.setState({ sortBy: sortBy, sortOrder: sortOrder })
	}
	sortFunc(sortBy, sortOrder) {
		return function (a, b) {
			if (sortBy === "status" || sortBy === "ActivityDateTime") {
				if ('status' in a && 'status' in b) {
					if (!a.loggedIn && !b.loggedIn) {
						return a.name > b.name ? 1 * sortOrder : -1 * sortOrder
					} else if (!a.loggedIn) {
						return 1
					} else if (!b.loggedIn) {
						return -1
					}
					if (a[sortBy] === b[sortBy]) {
						return a.name > b.name ? 1 * sortOrder : -1 * sortOrder
					}
					return a[sortBy] > b[sortBy] ? 1 * sortOrder : -1 * sortOrder
				} else {
					if ('status' in a) {
						return -1
					}
					return 1
				}
			}

			if (sortBy in a && sortBy in b) {
				if (a[sortBy] === b[sortBy]) {
					return a.email > b.email ? 1 * sortOrder : -1 * sortOrder
				}
				return a[sortBy] > b[sortBy] ? 1 * sortOrder : -1 * sortOrder
			} else if (!(sortBy in a) && !(sortBy in b)) {
				return a.email > b.email ? 1 * sortOrder : -1 * sortOrder
			} else {
				return sortBy in a ? -1 : 1
			}
		}
	}
	filterFunc(array, filterBy) {
		return array.filter(function (object) {
			for (var prop in filterBy) {
				if (typeof object[prop] === "undefined") {
					return false
				}
				if (object[prop].toString().toLowerCase().indexOf(filterBy[prop].toString().toLowerCase()) < 0) {
					return false
				}
			}
			return true
		})
	}
	filterIcon(item) {
		return (this.state.sortBy === item ? (this.state.sortOrder == 1) ? " \u25B2" : " \u25BC" : "")
	}

	//edit
	//delete

	//Domain Name
	//Domain ID
	//Creation Date
	//Icons 
	//Color

	//Add Domain
	addDomain = () => {
		var tempFeatures = JSON.parse(JSON.stringify(this.props.data.Domains.settings.features))
		//go through feature object and add a enabled entry set to false 
		for (var feature in tempFeatures) {
			tempFeatures[feature].enabled = false
		}

		console.log(tempFeatures)
		this.setState({
			addDomain: true,
			editDomain: false,
			tab: "basic",
			tempDomain: {
				"name": "",
				"id": "",
				"color": "#002f5f",
				"icon": "building",
				"creationDate": new Date().toJSON(),
				"features": tempFeatures
			}
		})
	}
	handleTabChange = (e) => {
		this.setState({ tab: e })
	}
	handleDomainChange = (e, item) => {
		var tempDomain = this.state.tempDomain
		tempDomain[item] = e.target.value
		this.setState({ tempDomain: tempDomain })
	}
	handleIDChange = (e) => {
		// Convert lowercase characters to uppercase
		const uppercaseValue = e.target.value.toUpperCase();

		// Remove special characters using regular expression
		const sanitizedValue = uppercaseValue.replace(/[^A-Z0-9]/g, '');

		// Update the state with the sanitized value
		this.setState({ tempDomain: { ...this.state.tempDomain, id: sanitizedValue } });
	};
	handleFeatureChange = (value, item) => {
		var tempDomain = this.state.tempDomain
		tempDomain.features[item].enabled = value
		this.setState({ tempDomain: tempDomain })
	}
	completeWizard = () => {
		this.setState({ loading: true })
		var tempDomain = this.state.tempDomain
		tempDomain.id = tempDomain.id
		tempDomain.name = tempDomain.name
		tempDomain.creationDate = new Date().toJSON()
		this.props.ws.send(JSON.stringify({ route: 'createDomain', domain: tempDomain }))
		//update state to not be editing
		this.setState({ addDomain: false, loading: false, tempDomain: null })
	}
	deleteDomain = () => {
		this.setState({ loading: true })
		var tempDomain = this.state.tempDomain
		tempDomain.id = tempDomain.id
		tempDomain.name = tempDomain.name
		tempDomain.creationDate = new Date().toJSON()
		this.props.ws.send(JSON.stringify({ route: 'deleteDomain', domain: tempDomain }))
		//update state to not be editing
		this.setState({ addDomain: false, loading: false, tempDomain: null })
	}
	componentWillReceiveProps(nextProps) {
		if (this.state.loading) {
			this.cancel()
		}
	}

	//Password Change
	incrementPasswordSetting = (settingKey, oppositeKey) => {
		const { passwords } = this.state.tempDomain.features.Users.settings;
		//if the value does not exist set it to 0
		if (!passwords[settingKey]) {
			passwords[settingKey] = 0;
		}


		if (passwords[settingKey] >= 250) {
			// Max value reached, do nothing
			return;
		}


		passwords[settingKey] = parseInt(passwords[settingKey]) + 1;

		// Check if the opposite key crosses the current setting value
		if (oppositeKey && passwords[settingKey] > passwords[oppositeKey]) {
			passwords[oppositeKey] = passwords[settingKey];
		}

		// Update the state if necessary
		this.setState({});
	}
	decrementPasswordSetting = (settingKey, oppositeKey) => {
		const { passwords } = this.state.tempDomain.features.Users.settings;

		if (passwords[settingKey] <= 0) {
			// Min value reached, do nothing
			return;
		}

		passwords[settingKey] = passwords[settingKey] - 1;

		// Check if the opposite key crosses the current setting value
		if (oppositeKey && passwords[settingKey] < passwords[oppositeKey]) {
			passwords[oppositeKey] = passwords[settingKey];
		}

		// Update the state if necessary
		this.setState({});
	}
	settingsPasswordChange = (settingKey, value) => {
		this.state.tempDomain.features.Users.settings.passwords[settingKey] = value;
		// Update the state if necessary
		this.setState({}); // Empty setState to
	}

	//Domain Changes
	handleDomainFeatureChange = (value) => {
		// if this.state.tempDomain.features.Domains.features contains value remove it, if it doesnt include it add it 
		var tempDomain = this.state.tempDomain
		if (tempDomain.features.Domains.settings.includes(value)) {
			tempDomain.features.Domains.settings.splice(tempDomain.features.Domains.settings.indexOf(value), 1)
		} else {
			tempDomain.features.Domains.settings.push(value)
		}
		this.setState({ tempDomain: tempDomain })
	}

	//Report Changes
	toggleReport = (key, value) => {
		this.state.tempDomain.features.Reports.settings.reports[key].enabled = value;
		this.setState({}); // Empty setState to

	}

	generateRandomID = () => {
		const randomID = Math.floor(1000 + Math.random() * 9000); // Generate a random 4-digit number
		this.state.tempDomain.features.Reports.settings.applicationID = randomID.toString(); // Set the random number as the Application ID
		this.setState({}); // Empty setState to
	};

	handleReportIDChange = (e) => {
		//Add code here so that it only accepts numbers and limits it 4 characters
		if (e.target.value.length > 4) {
			return
		}
		//check that it is a number
		if (isNaN(e.target.value)) {
			return
		}

		this.state.tempDomain.features.Reports.settings.applicationID = e.target.value;
		this.setState({}); // Empty setState to
	}

	//Prompt Changes
	handleAddLanguage = (e) => {
		var tempDomain = this.state.tempDomain
		tempDomain.features.Prompts.settings.language.push(e.target.value)
		this.setState({ tempDomain: tempDomain })
	};

	handleRemoveLanguage = (language) => {
		var tempDomain = this.state.tempDomain
		tempDomain.features.Prompts.settings.language.splice(tempDomain.features.Prompts.settings.language.indexOf(language), 1)
		this.setState({ tempDomain: tempDomain })

	};

	promptListChange = (prompt) => {
		//Add value to array and update state
		var tempDomain = this.state.tempDomain
		if (tempDomain.features.Prompts.settings.types.includes(prompt)) {
			tempDomain.features.Prompts.settings.types.splice(tempDomain.features.Prompts.settings.types.indexOf(prompt), 1)
		} else {
			tempDomain.features.Prompts.settings.types.push(prompt)
		}
		this.setState({ tempDomain: tempDomain })
	}


	/*
		Example
		"data": [
			{	
				"name": "Skidmore College",
				"id": "Skidmore",
				"color": "#FF0000",
				"icon": "building",
				"creationDate": {}
			  }
		]	
	*/


	render() {
		if (this.props.active) {
			var domList = []
			var domains = JSON.parse(JSON.stringify(this.props.data.Domains.data))
			//turn features into an array of items 


			if (Object.keys(this.state.filterBy).length > 0) {
				domains = this.filterFunc(domains, this.state.filterBy)
			}

			if (this.state.sortBy !== '') {
				domains.sort(this.sortFunc(this.state.sortBy, this.state.sortOrder))
			}


			//All the code to manage adding a domain
			var addDomain = ""
			if (this.state.addDomain) {
				const colorOptions = [
					{ value: '#002f5f', label: 'Blue', color: '#002f5f' },
					{ value: '#578B49', label: 'Green', color: '#578B49' },
					{ value: '#5F645E', label: 'Grey', color: '#5F645E' },
					{ value: '#402B80', label: 'Purple', color: '#402B80' },
				];
				const iconOptions = [
					{ value: 'user', label: 'User', icon: <FaUser style={{ fontSize: '1.2rem' }} /> },
					{ value: 'phone', label: 'Phone', icon: <FaPhone style={{ fontSize: '1.2rem' }} /> },
					{ value: 'building', label: 'Building', icon: <FaBuilding style={{ fontSize: '1.2rem' }} /> },
					{ value: 'comment', label: 'Comment', icon: <FaComment style={{ fontSize: '1.2rem' }} /> }
				];
				var tabHeaders = [
					{ id: 'basic', label: 'Basic' },
					{ id: 'features', label: 'Features' }
				];
				//for each feature active in the domain, add it to the tab headers 
				for (var feature in this.state.tempDomain.features) {
					if (this.state.tempDomain.features[feature].enabled && this.state.tempDomain.features[feature].settings) {
						tabHeaders.push({ id: feature, label: feature })
					}
				}
				//put summary back at the end of tab headers
				tabHeaders.push({ id: 'summary', label: 'Summary' })

				var tabArray = tabHeaders.map((tab) => {
					return tab.id
				})



				const currentTabIndex = tabHeaders.findIndex((tab) => tab.id === this.state.tab);
				const isLastTab = currentTabIndex === tabHeaders.length - 1;

				const goToNextTab = () => {
					const currentTabIndex = tabHeaders.findIndex((tab) => tab.id === this.state.tab);
					const nextTabIndex = currentTabIndex + 1;

					if (nextTabIndex < tabHeaders.length) {
						const nextTabId = tabHeaders[nextTabIndex].id;
						this.setState({ tab: nextTabId });
					}
				};

				const goToPreviousTab = () => {
					const currentTabIndex = tabHeaders.findIndex((tab) => tab.id === this.state.tab);
					const previousTabIndex = currentTabIndex - 1;

					if (previousTabIndex >= 0) {
						const previousTabId = tabHeaders[previousTabIndex].id;
						this.setState({ tab: previousTabId });
					}
				};

				addDomain = (
					<div className="blackout" tabIndex="1" autoFocus onKeyUp={this.checkEnter}>
						<div className="pop" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
							<div className="viewCloser" onClick={this.cancel}></div>
							<div className="error">{this.state.error}</div>
							<div className="tab-header" style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
								{tabHeaders.map((tab, index) => (
									<div className="tab" key={tab.id} style={{
										padding: '10px',
										cursor: 'default',
										background: this.state.tab === tab.id ? '#2A6AA9' : '#fff',
										color: this.state.tab === tab.id ? '#fff' : '#2A6AA9',
										border: '1px solid #2A6AA9',
										flex: 1,
										textAlign: 'center',
										borderTopLeftRadius: index === 0 ? '4px' : 0,
										borderBottomLeftRadius: index === 0 ? '4px' : 0,
										borderTopRightRadius: index === tabHeaders.length - 1 ? '4px' : 0,
										borderBottomRightRadius: index === tabHeaders.length - 1 ? '4px' : 0,
									}} onClick={() => this.handleTabChange(tab.id)}>
										<span style={{ color: this.state.tab === tab.id ? '#fff' : '#2A6AA9' }}>{tab.label}</span>
									</div>
								))}
							</div>
							{tabHeaders.map((tab) => (
								<div key={tab.id} style={{ display: this.state.tab === tab.id ? 'block' : 'none' }} width="100%">
									{/*Basic Tab*/}
									{tab.id === 'basic' && (
										<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '20px' }}>
											<div className="inputLabel" style={{ marginBottom: '10px' }}>Name</div>
											<input
												className="input"
												type="text"
												value={this.state.tempDomain.name}
												onChange={(e) => this.handleDomainChange(e, 'name')}
												placeholder="Name"
												style={{ width: '250px', padding: '8px', border: '1px solid #ccc', borderRadius: '4px', marginBottom: '10px' }}
											/>
											<div className="inputLabel" style={{ marginBottom: '10px' }}>ID</div>
											{this.state.editDomain ? (
												<div style={{ marginBottom: '10px', fontSize: '16px', fontWeight: 'bold' }}>{this.state.tempDomain.id}</div>
											) : (
												<input
													className="input"
													type="text"
													value={this.state.tempDomain.id}
													onChange={(e) => this.handleIDChange(e)}
													placeholder="ID"
													style={{ width: '250px', padding: '8px', border: '1px solid #ccc', borderRadius: '4px', marginBottom: '10px' }}
													pattern="[A-Za-z]{3}" // Restrict input to capital letters and numbers
												/>)}
											<div className="inputLabel" style={{ marginBottom: '10px' }}>Color</div>
											<div style={{ display: 'flex', marginBottom: '10px' }}>
												{colorOptions.map((option) => (
													<button
														key={option.value}
														onClick={() => this.handleDomainChange({ target: { value: option.value } }, 'color')}
														style={{
															width: this.state.tempDomain.color === option.value ? '50px' : '40px', // Increase the width for bigger icons
															height: this.state.tempDomain.color === option.value ? '50px' : '40px', // Increase the height for bigger icons
															backgroundColor: option.color,
															border: this.state.tempDomain.color === option.value ? '2px solid #333' : '2px solid transparent',
															borderRadius: '4px',
															margin: '0 10px', // Add horizontal margin between items
														}}
													></button>
												))}
											</div>
											<div className="inputLabel" style={{ marginBottom: '10px' }}>Icon</div>
											<div style={{ display: 'flex', marginBottom: '10px' }}>
												{iconOptions.map((option) => (
													<button
														key={option.value}
														onClick={() => this.handleDomainChange({ target: { value: option.value } }, 'icon')}
														style={{
															width: option.value === this.state.tempDomain.icon ? '50px' : '40px', // Increase the width for bigger icons
															height: option.value === this.state.tempDomain.icon ? '50px' : '40px', // Increase the height for bigger icons
															borderRadius: '4px',
															margin: '0 10px', // Add horizontal margin between items
															backgroundColor: option.value === this.state.tempDomain.icon ? '#2A6AA9' : '#2A6AA9', // Change button color when selected and not selected
															border: option.value === this.state.tempDomain.icon ? '2px solid black' : 'none', // Add black outline when selected
															display: 'flex',
															justifyContent: 'center',
															alignItems: 'center',
															color: option.value === this.state.tempDomain.icon ? '#fff' : '#fff', // Change icon color when selected and not selected
														}}
													>
														{option.icon}
													</button>
												))}
											</div>
										</div>
									)}

									{/*Features Tab*/}
									{tab.id === 'features' && (
										<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', padding: '20px' }}>
											{Object.entries(this.state.tempDomain.features).map(([key, value]) => (
												<div key={key} style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
													<input
														type="checkbox"
														checked={value.enabled}
														onChange={() => this.handleFeatureChange(!value.enabled, key)}
														style={{ marginRight: '10px' }}
													/>
													<div className="feature-name">{value.name}</div>
												</div>
											))}
										</div>
									)}
									{/* Users Tab
									{tab.id === 'Users' && (
										<div className="form-grid" style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '5px', padding: '20px' }}>

											<div style={{ border: '1px solid #ccc', borderRadius: '5px', padding: '20px 40px 5px' }}>
												<div>
													<label style={{ fontWeight: 'bold', marginBottom: '10px' }}>Password Length</label>
													<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '180px', marginBottom: '10px', marginTop: '5px' }}>
														<div style={{ padding: '10px' }}>
															<label>Min.</label>
															<div style={{ display: 'flex', alignItems: 'center' }}>
																<button onClick={() => this.decrementPasswordSetting('minLength')} style={{ width: '30px', height: '30px', textAlign: 'center', backgroundColor: '#2A6AA9', borderStyle: 'none', color: '#ffffff', borderRadius: '5px', borderStyle: 'none', fontSize: '16px', cursor: 'pointer' }}>-</button>
																<input
																	type="text"
																	value={this.state.tempDomain.features.Users.settings.passwords.minLength || 0}
																	onChange={(e) => this.settingsPasswordChange('minLength', e.target.value)}
																	style={{ width: '40px', height: '30px', textAlign: 'center', borderRadius: '5px', fontSize: '18px', padding: '0 5px', borderStyle: 'none', border: 'none', fontWeight: 'bold', color: '#137' }}
																/>
																<button onClick={() => this.incrementPasswordSetting('minLength', 'maxLength')} style={{ width: '30px', height: '30px', textAlign: 'center', backgroundColor: '#2A6AA9', color: '#ffffff', borderStyle: 'none', borderRadius: '5px', fontSize: '16px', cursor: 'pointer' }}>+</button>
															</div>
														</div>
														<div style={{ padding: '10px' }}>
															<label>Max.</label>
															<div style={{ display: 'flex', alignItems: 'center' }}>
																<button onClick={() => this.decrementPasswordSetting('maxLength', 'minLength')} style={{ width: '30px', height: '30px', textAlign: 'center', backgroundColor: '#2A6AA9', color: '#ffffff', borderStyle: 'none', borderRadius: '5px', fontSize: '16px', cursor: 'pointer' }}>-</button>
																<input
																	type="text"
																	value={this.state.tempDomain.features.Users.settings.passwords.maxLength || 0}
																	onChange={(e) => this.settingsPasswordChange('maxLength', e.target.value)}
																	style={{ width: '40px', height: '30px', textAlign: 'center', borderRadius: '5px', fontSize: '18px', borderStyle: 'none', border: 'none', fontWeight: 'bold', color: '#137' }}
																/>
																<button onClick={() => this.incrementPasswordSetting('maxLength')} style={{ width: '30px', height: '30px', textAlign: 'center', backgroundColor: '#2A6AA9', color: '#ffffff', borderStyle: 'none', borderRadius: '5px', fontSize: '16px', cursor: 'pointer' }}>+</button>
															</div>
														</div>
													</div>
												</div>
											</div>

											<div style={{ border: '1px solid #ccc', borderRadius: '5px', padding: '20px 40px 5px' }}>
												<div>
													<label style={{ fontWeight: 'bold', marginBottom: '10px' }}>Password Age (Days)</label>
													<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '180px', marginBottom: '10px', marginTop: '5px' }}>
														<div style={{ padding: '10px' }}>
															<label>Min.</label>
															<div style={{ display: 'flex', alignItems: 'center' }}>
																<button onClick={() => this.decrementPasswordSetting('minAge')} style={{ width: '30px', height: '30px', textAlign: 'center', backgroundColor: '#2A6AA9', borderStyle: 'none', color: '#ffffff', borderRadius: '5px', borderStyle: 'none', fontSize: '16px', cursor: 'pointer' }}>-</button>
																<input
																	type="text"
																	value={this.state.tempDomain.features.Users.settings.passwords.minAge || 0}
																	onChange={(e) => this.settingsPasswordChange('minAge', e.target.value)}
																	style={{ width: '40px', height: '30px', textAlign: 'center', borderRadius: '5px', fontSize: '18px', padding: '0 5px', borderStyle: 'none', border: 'none', fontWeight: 'bold', color: '#137' }}
																/>
																<button onClick={() => this.incrementPasswordSetting('minAge', 'maxAge')} style={{ width: '30px', height: '30px', textAlign: 'center', backgroundColor: '#2A6AA9', color: '#ffffff', borderStyle: 'none', borderRadius: '5px', fontSize: '16px', cursor: 'pointer' }}>+</button>
															</div>
														</div>
														<div style={{ padding: '10px' }}>
															<label>Max.</label>
															<div style={{ display: 'flex', alignItems: 'center' }}>
																<button onClick={() => this.decrementPasswordSetting('maxAge', 'minAge')} style={{ width: '30px', height: '30px', textAlign: 'center', backgroundColor: '#2A6AA9', color: '#ffffff', borderStyle: 'none', borderRadius: '5px', fontSize: '16px', cursor: 'pointer' }}>-</button>
																<input
																	type="text"
																	value={this.state.tempDomain.features.Users.settings.passwords.maxAge || 0}
																	onChange={(e) => this.settingsPasswordChange('maxAge', e.target.value)}
																	style={{ width: '40px', height: '30px', textAlign: 'center', borderRadius: '5px', fontSize: '18px', borderStyle: 'none', border: 'none', fontWeight: 'bold', color: '#137' }}
																/>
																<button onClick={() => this.incrementPasswordSetting('maxAge')} style={{ width: '30px', height: '30px', textAlign: 'center', backgroundColor: '#2A6AA9', color: '#ffffff', borderStyle: 'none', borderRadius: '5px', fontSize: '16px', cursor: 'pointer' }}>+</button>
															</div>
														</div>
													</div>
												</div>
											</div>

											<div style={{ border: '1px solid #ccc', borderRadius: '5px', padding: '20px 40px 5px' }}>
												<div>
													<label style={{ fontWeight: 'bold', marginBottom: '10px' }}>Security</label>
													<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '180px', marginBottom: '10px', marginTop: '5px' }}>
														<div style={{ padding: '10px' }}>
															<label>Timeout (Minutes)</label>
															<div style={{ display: 'flex', alignItems: 'center' }}>
																<button onClick={() => this.decrementPasswordSetting('lockTimeout')} style={{ width: '30px', height: '30px', textAlign: 'center', backgroundColor: '#2A6AA9', borderStyle: 'none', color: '#ffffff', borderRadius: '5px', borderStyle: 'none', fontSize: '16px', cursor: 'pointer' }}>-</button>
																<input
																	type="text"
																	value={this.state.tempDomain.features.Users.settings.passwords.lockTimeout || 0}
																	onChange={(e) => this.settingsPasswordChange('lockTimeout', e.target.value)}
																	style={{ width: '40px', height: '30px', textAlign: 'center', borderRadius: '5px', fontSize: '18px', padding: '0 5px', borderStyle: 'none', border: 'none', fontWeight: 'bold', color: '#137' }}
																/>
																<button onClick={() => this.incrementPasswordSetting('lockTimeout')} style={{ width: '30px', height: '30px', textAlign: 'center', backgroundColor: '#2A6AA9', color: '#ffffff', borderStyle: 'none', borderRadius: '5px', fontSize: '16px', cursor: 'pointer' }}>+</button>
															</div>
														</div>
														<div style={{ padding: '10px' }}>
															<label>Failed Attempts</label>
															<div style={{ display: 'flex', alignItems: 'center' }}>
																<button onClick={() => this.decrementPasswordSetting('maxFailedAttempts')} style={{ width: '30px', height: '30px', textAlign: 'center', backgroundColor: '#2A6AA9', color: '#ffffff', borderStyle: 'none', borderRadius: '5px', fontSize: '16px', cursor: 'pointer' }}>-</button>
																<input
																	type="text"
																	value={this.state.tempDomain.features.Users.settings.passwords.maxFailedAttempts || 0}
																	onChange={(e) => this.settingsPasswordChange('maxFailedAttempts', e.target.value)}
																	style={{ width: '40px', height: '30px', textAlign: 'center', borderRadius: '5px', fontSize: '18px', borderStyle: 'none', border: 'none', fontWeight: 'bold', color: '#137' }}
																/>
																<button onClick={() => this.incrementPasswordSetting('maxFailedAttempts')} style={{ width: '30px', height: '30px', textAlign: 'center', backgroundColor: '#2A6AA9', color: '#ffffff', borderStyle: 'none', borderRadius: '5px', fontSize: '16px', cursor: 'pointer' }}>+</button>
															</div>
														</div>
													</div>
												</div>
											</div>

											<div style={{ border: '1px solid #ccc', borderRadius: '5px', padding: '20px 40px 5px' }}>
												<div>
													<label style={{ fontWeight: 'bold', marginBottom: '10px' }}>Complexity</label>
													<div style={{ display: 'grid', gridGap: '10px', marginBottom: '10px', marginTop: '5px' }}>
														<div style={{ display: 'flex', alignItems: 'center' }}>
															<input
																type="checkbox"
																checked={this.state.tempDomain.features.Users.settings.passwords.uppercase}
																onChange={(e) => this.settingsPasswordChange('uppercase', e.target.checked)}
																style={{ marginRight: '5px' }}
															/>
															<label>Uppercase</label>
														</div>
														<div style={{ display: 'flex', alignItems: 'center' }}>
															<input
																type="checkbox"
																checked={this.state.tempDomain.features.Users.settings.passwords.lowercase}
																onChange={(e) => this.settingsPasswordChange('lowercase', e.target.checked)}
																style={{ marginRight: '5px' }}
															/>
															<label>Lowercase</label>
														</div>
														<div style={{ display: 'flex', alignItems: 'center' }}>
															<input
																type="checkbox"
																checked={this.state.tempDomain.features.Users.settings.passwords.number}
																onChange={(e) => this.settingsPasswordChange('number', e.target.checked)}
																style={{ marginRight: '5px' }}
															/>
															<label>Number</label>
														</div>
														<div style={{ display: 'flex', alignItems: 'center' }}>
															<input
																type="checkbox"
																checked={this.state.tempDomain.features.Users.settings.passwords.specialCharacter}
																onChange={(e) => this.settingsPasswordChange('specialCharacter', e.target.checked)}
																style={{ marginRight: '5px' }}
															/>
															<label>Special Character</label>
														</div>
													</div>
												</div>

											</div>


										</div>
									)} */}
									{/*Prompts Tab*/}
									{tab.id === 'Prompts' && (
										<div className="form-grid" style={{ display: 'grid', gridTemplateColumns: '1fr', gridGap: '1px', padding: '20px' }}>
											<div style={{ border: '1px solid #ccc', borderRadius: '5px', padding: '20px', marginBottom: '10px', minWidth: '250px' }}>
												{/* Prompt Types code */}
												<div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
													<label style={{ fontWeight: 'bold' }}>Prompt Types</label>
												</div>
												<div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
													<input
														type="checkbox"
														checked={this.state.tempDomain.features.Prompts.settings.types.includes('special')}
														onChange={(e) => this.promptListChange('special', e.target.checked)}
														style={{ marginRight: '5px' }}
													/>
													<label>Special</label>
												</div>
												<div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
													<input
														type="checkbox"
														checked={this.state.tempDomain.features.Prompts.settings.types.includes('system')}
														onChange={(e) => this.promptListChange('system', e.target.checked)}
														style={{ marginRight: '5px' }}
													/>
													<label>System</label>
												</div>
												<div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
													<input
														type="checkbox"
														checked={this.state.tempDomain.features.Prompts.settings.types.includes('custom')}
														onChange={(e) => this.promptListChange('custom', e.target.checked)}
														style={{ marginRight: '5px' }}
													/>
													<label>Custom</label>
												</div>
											</div>

											<div style={{ border: '1px solid #ccc', borderRadius: '5px', padding: '20px', marginBottom: '10px' }}>
												{/* Languages code */}
												<label style={{ fontWeight: 'bold', marginBottom: '10px' }}>Languages</label>
												<div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
													<div style={{
														border: '1px solid #aaa',
														borderRadius: '5px',
														padding: '5px 10px',
														minHeight: '30px',
														width: '100%',
														display: 'flex',
														flexWrap: 'wrap',
														justifyContent: 'flex-start',
														alignItems: 'center',
														marginBottom: '10px'
													}}>
														{this.state.tempDomain.features.Prompts.settings.language.map((language, index) => (
															<div key={index} onClick={() => this.handleRemoveLanguage(language)} style={{ margin: '5px', padding: '3px', border: '1px solid #777', borderRadius: '5px', cursor: 'pointer' }}>
																{language}
															</div>
														))}
													</div>

													<select onChange={this.handleAddLanguage} style={{ padding: '5px', border: '1px solid #777', borderRadius: '5px', width: '100%' }}>
														<option value="">Select a language</option>
														{this.state.availableLanguages.map((language, index) => (
															<option key={index} value={language}>
																{language}
															</option>
														))}
													</select>
												</div>
											</div>
											<div style={{ border: '1px solid #ccc', borderRadius: '1px', padding: '5px', marginBottom: '5px' }}>
												<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer' }}>
													<div>Admin Settings</div>
													<div
														onClick={() => this.setState({ showAdminSettings: !this.state.showAdminSettings })}
														style={{ transform: this.state.showAdminSettings ? 'rotate(90deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }}
													>
														&#10148;
													</div>
												</div>
												{this.state.showAdminSettings && (
													<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '20px' }}>
														<div className="inputLabel" style={{ marginBottom: '10px' }}>Hosting URL</div>
														<input
															className="input"
															type="text"
															placeholder="Web URL"
															value={this.state.tempDomain.features.Prompts.settings.webURL}
															onChange={(e) => {
																this.state.tempDomain.features.Prompts.settings.webURL = e.target.value;
																this.setState({});
															}}
															style={{ width: '250px', padding: '8px', border: '1px solid #777', borderRadius: '4px', marginBottom: '10px' }}
														/>
														<div className="inputLabel" style={{ marginBottom: '10px' }}>Import System Prompts</div>
														<div style={{ display: 'flex', marginBottom: '10px', alignItems: 'center' }}>
															<input
																type="checkbox"
																checked={this.state.importSystemPrompts}
																onChange={(e) => this.setState({ importSystemPrompts: e.target.checked })}
																style={{ marginRight: '5px' }}
															/>
															<label>Import System Prompts</label>
														</div>
														{this.state.importSystemPrompts && (
															<div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
																<input
																	className="input"
																	type="text"
																	placeholder="URL"
																	value={this.state.tempDomain.features.Prompts.settings.url}
																	onChange={(e) => {
																		this.state.tempDomain.features.Prompts.settings.url = e.target.value;
																		this.setState({});
																	}}
																	style={{ width: '250px', padding: '8px', border: '1px solid #777', borderRadius: '4px' }}
																/>
																<input
																	className="input"
																	type="text"
																	placeholder="Username"
																	value={this.state.tempDomain.features.Prompts.settings.flowCreds.username}
																	onChange={(e) => {
																		this.state.tempDomain.features.Prompts.settings.flowCreds.username = e.target.value;
																		this.setState({});
																	}}
																	style={{ width: '250px', padding: '8px', border: '1px solid #777', borderRadius: '4px' }}
																/>
																<input
																	className="input"
																	type="password"
																	placeholder="Password"
																	value={this.state.tempDomain.features.Prompts.settings.flowCreds.password}
																	onChange={(e) => {
																		this.state.tempDomain.features.Prompts.settings.flowCreds.password = e.target.value;
																		this.setState({});
																	}}
																	style={{ width: '250px', padding: '8px', border: '1px solid #777', borderRadius: '4px' }}
																/>
															</div>
														)}
													</div>
												)}
											</div>



										</div>
									)}
									{/* Reports Tab */}
									{tab.id === 'Reports' && (
										<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', padding: '20px' }}>
											<div className="inputLabel" style={{ marginBottom: '10px' }}>Application ID</div>
											{this.state.editDomain ? (
												<div style={{ marginBottom: '10px', fontSize: '16px', fontWeight: 'bold' }}>{this.state.tempDomain.features.Reports.settings.applicationID}</div>
											) : (
												<div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
													<input
														className="input"
														type="text"
														value={this.state.tempDomain.features.Reports.settings.applicationID}
														onChange={(e) => this.handleReportIDChange(e)}
														placeholder="Application ID"
														style={{ width: '200px', padding: '8px', border: '1px solid #ccc', borderRadius: '4px', marginBottom: '10px' }}
													/>
													<button onClick={this.generateRandomID} className='button' style={{ marginLeft: '10px', padding: '4px 8px' }}>Generate</button>
												</div>
											)}
											<div style={{ marginBottom: '10px' }}>Reports</div>
											{Object.entries(this.state.tempDomain.features.Reports.settings.reports).map(([key, value]) => (
												<div key={key} style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
													<input
														type="checkbox"
														checked={this.state.tempDomain.features.Reports.settings.reports[key].enabled}
														onChange={() => this.toggleReport(key, !this.state.tempDomain.features.Reports.settings.reports[key].enabled)}
														style={{ marginRight: '10px' }}
													/>
													<div className="report-name">{value.name}</div>
												</div>
											))}
										</div>
									)}


									{/*Domains Tab*/}
									{tab.id === 'Domains' && (
										<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', padding: '20px' }}>
											<div style={{ marginBottom: '10px' }}>Domains</div>
											{Object.entries(this.state.tempDomain.features).map(([key, value]) => (
												<div key={key} style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
													<input
														type="checkbox"
														checked={(this.state.tempDomain.features.Domains.settings.includes(key))}
														onChange={() => this.handleDomainFeatureChange(key)}
														style={{ marginRight: '10px' }}
													/>
													<div className="feature-name">{value.name}</div>
												</div>
											))}
										</div>
									)}
									{/* Summary Tab */}
									{tab.id === 'summary' && this.state.tempDomain && (
										<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '20px' }}>
											<h3>Summary</h3>
											<table style={{ marginBottom: '20px' }}>
												<tbody>
													<tr>
														<td>Name:</td>
														<td>{this.state.tempDomain.name}</td>
													</tr>
													<tr>
														<td>ID:</td>
														<td>{this.state.tempDomain.id}</td>
													</tr>
												</tbody>
											</table>

											<h4>Features</h4>
											<table style={{ marginBottom: '20px' }}>
												<tbody>
													{Object.entries(this.state.tempDomain.features).map(([key, value]) => (
														<tr key={key}>
															<td>{value.name}:</td>
															<td>{value.enabled ? 'Enabled' : 'Disabled'}</td>
														</tr>
													))}
												</tbody>
											</table>

											{tabArray.includes("Reports") && (
												<div>
													<h4>Reports</h4>
													<table style={{ marginBottom: '20px' }}>
														<tbody>
															<tr>
																<td>Application ID:</td>
																<td>{this.state.tempDomain.features.Reports.settings.applicationID}</td>
															</tr>
															{Object.entries(this.state.tempDomain.features.Reports.settings.reports).map(([key, value]) => (
																<tr key={key}>
																	<td>{value.name}:</td>
																	<td>{value.enabled ? 'Enabled' : 'Disabled'}</td>
																</tr>
															))}
														</tbody>
													</table>
												</div>
											)}

											{tabArray.includes("Domains") && (
												<div>
													<h4>Domain Features</h4>
													<table>
														<tbody>
															{Object.entries(this.state.tempDomain.features).map(([key, value]) => (
																<tr key={key}>
																	<td>{value.name}:</td>
																	<td>{this.state.tempDomain.features.Domains.settings.includes(key) ? 'Enabled' : 'Disabled'}</td>
																</tr>
															))}
														</tbody>
													</table>
												</div>
											)}
										</div>
									)}




								</div>
							))}
							<div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', marginTop: '10px' }}>
								{this.state.editDomain && currentTabIndex === 0 ? (
									<div
										className="button back"
										onClick={this.deleteDomain} // Add the function for deleting here
										title="Delete"
										style={{ color: '#fff' }} // Set the color to red for delete
									>
										<FaTrash style={{ fontSize: '1.8rem' }} />
									</div>
								) : (
									<>
										{currentTabIndex === 0 ? (
											<> </>
										) : ((<div
											className="button back"
											onClick={goToPreviousTab}
											title="Go Back"
										>
											<FaArrowLeft style={{ fontSize: '1.2rem', color: '#fff' }} />
										</div>))
										}
									</>
								)}
								<div
									className="button forward"
									onClick={isLastTab ? this.completeWizard : goToNextTab}
									title={isLastTab ? 'Complete' : 'Go Forward'}
									style={{ color: isLastTab ? '#fff' : '#fff' }}
								>
									{isLastTab ? 'Complete' : <FaArrowRight style={{ fontSize: '1.2rem' }} />}
								</div>
							</div>

						</div>
					</div>
				);
			}




			for (var domain of domains) {
				const IconComponent = iconComponents[domain.icon] || FaUser;
				const handleMouseEnter = (color) => (event) => {
					const targetRow = event.target.closest('.dataRow');
					targetRow.style.color = '#fff';
					targetRow.querySelectorAll('svg').forEach((icon) => {
						icon.style.color = '#fff';
					});
				};
				const handleMouseLeave = (color) => (event) => {
					const targetRow = event.target.closest('.dataRow');
					targetRow.style.color = color;
					targetRow.querySelectorAll('svg').forEach((icon) => {
						icon.style.color = color;
					});
				};
				const handleMouseClick = (id) => (event) => {
					console.log(id);
					this.props.ws.send(JSON.stringify({ route: 'impersonate', domain: id }))
				};
				const handleEditClick = (id) => (event) => {
					var tempDomain = JSON.parse(JSON.stringify(this.props.data.Domains.data.find((domain) => domain.id === id)))
					this.setState({
						addDomain: true,
						editDomain: true,
						tab: "basic",
						tempDomain: tempDomain
					})
				};

				domList.push(
					<tr
						className="dataRow"
						onClick={handleMouseClick(domain.id)}
						key={domain.id}
						style={{ color: domain.color }}
						onMouseEnter={handleMouseEnter(domain.color)}
						onMouseLeave={handleMouseLeave(domain.color)}
					>
						<td
							style={{
								flex: '1 0 350px',
								textAlign: 'left',
								display: 'flex',
								alignItems: 'center',
							}}
						>
							<IconComponent style={{ color: domain.color, marginRight: '10px' }} />
							<span style={{ fontWeight: 'bold' }}>{domain.name}</span>
						</td>
						<td style={{ flex: '0 0 180px', textAlign: 'left' }}>{domain.id}</td>
						<td style={{ flex: '0 0 80px', textAlign: 'left' }}>{"0"}</td>
						<td style={{ flex: '0 0 100px', textAlign: 'right' }}>
							<button
								style={{
									width: '54px',
									height: '29px',
									borderRadius: '4px',
									backgroundColor: domain.color,
									border: `1px solid ${domain.color}`
								}}
								onClick={(e) => {
									e.stopPropagation(); // Prevent the click event from bubbling
									handleEditClick(domain.id)();
								}}
							>
								<span style={{ color: '#fff', fontSize: '14px', fontWeight: 'bold' }}>Edit</span>
							</button>
						</td>
					</tr>
				);

			}

			var addButton = ""
			addButton = <img src={this.props.img.plus} className="plusButton" alt="Add a Domain" onClick={this.addDomain} />
			return (
				<div width="100%">
					{addButton}
					<div style={{ display: 'flex', flexWrap: 'wrap' }}>
						<div style={{ width: '280px', marginRight: '10px' }}>
							<div style={{ display: 'flex', alignItems: 'left', marginBottom: '20px', marginTop: '10px' }}>
							</div>
							<div className="filterBox">
								<h4>Filter By:</h4>
								<div style={{ width: '250px' }}>
									<label>Name:</label>
									<input type="text" onChange={this.filter("name")} value={this.state.filterBy.name} />
								</div>
								<div style={{ width: '250px' }}>
									<label>Code:   </label>
									<input type="text" onChange={this.filter("id")} value={this.state.filterBy.id} />
								</div>
							</div>
						</div>
						<div style={{ flex: 1 }}>
							<table>
								<thead>
									<tr className="dataRow">
										<th style={{ minWidth: '350px', cursor: 'pointer', textAlign: 'left' }} onClick={this.sort("name")}>Name {this.filterIcon("name")}</th>
										<th style={{ minWidth: '180px', cursor: 'pointer', textAlign: 'left' }} onClick={this.sort("id")}>Code {this.filterIcon("id")}</th>
										<th style={{ minWidth: '200px', cursor: 'pointer', textAlign: 'left' }}>Users { }</th>
									</tr>
								</thead>
								<tbody>
									{domList}
								</tbody>
							</table>
						</div>
					</div>
					{addDomain}
				</div>
			);
		} else {
			return (
				<div width="100%">

				</div>
			);
		}
	}

}

const icon = "menuWorld"
const roles = ["View", "Add", "Edit", "Delete", "Impersonate"]
export { Domains, icon, roles }